import { render, staticRenderFns } from "./DemoScreen.vue?vue&type=template&id=dca71cca&scoped=true"
import script from "./DemoScreen.vue?vue&type=script&lang=js"
export * from "./DemoScreen.vue?vue&type=script&lang=js"
import style0 from "./DemoScreen.vue?vue&type=style&index=0&id=dca71cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca71cca",
  null
  
)

export default component.exports